/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as n from "react";
import e from "prop-types";
const t = class t extends n.Component {
  render() {
    return null;
  }
};
t.propTypes = {
  left: e.oneOfType([e.number, e.string]),
  top: e.oneOfType([e.number, e.string]),
  right: e.oneOfType([e.number, e.string]),
  bottom: e.oneOfType([e.number, e.string])
};
let r = t;
export {
  r as PDFMargin
};
